export const SITE_ORIGIN = 'https://www.genproof.com';

// The wordmark on the left is the link home; the list carries the sections only.
export const SITE_LINKS = [
  { href: '/work', label: '[WORK]' },
  { href: '/blog', label: '[BLOG]' },
  { href: '/get-in-touch', label: '[GET IN TOUCH]' },
];

const pagePath = pathname => pathname.replace(/^\/preview(?=\/|$)/, '') || '/';

export function siteLinks() {
  return SITE_LINKS;
}

export function currentSection(pathname) {
  const path = pagePath(pathname);
  const under = base => path === base || path.startsWith(base + '/');
  if (path === '/') return '/';
  if (under('/blog')) return '/blog';
  if (under('/get-in-touch')) return '/get-in-touch';
  if (['/work', '/quickproof', '/reports', '/bugs', '/reported-bugs', '/agents', '/bug'].some(under)) return '/work';
  return null;
}

// The standalone bug pages use the same links and stylesheet as the React pages.
export function siteHeaderHtml({ origin = SITE_ORIGIN, active = '/work', fixed = false, gradient = false } = {}) {
  return `<nav class="site-header${fixed ? ' bar' : ''}${gradient ? ' site-header--bugs' : ''}" aria-label="Main navigation" data-site-header>
    <a class="site-header__home" href="${origin}/">genproof.com</a>
    <div class="site-header__links">${siteLinks().map(({ href, label }) => `<a href="${origin}${href}"${active === href ? ' aria-current="page"' : ''}>${label}</a>`).join('')}</div>
  </nav>`;
}

export function navigationOrigin(request) {
  const hostname = new URL(request.url).hostname;
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname.endsWith('.localhost') ? '' : SITE_ORIGIN;
}
